var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"pika",on:{"click":_vm.goHome}},[_c('img',{attrs:{"alt":"pika","src":require("@/assets/pika.gif")}})]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }